import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className, y = 30 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const SectionHeader = ({ eyebrow, title, subtitle }) => (
    <div className="max-w-2xl">
        <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold font-medium">{eyebrow}</p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-amber-50 leading-tight">{title}</h2>
        </Reveal>
        {subtitle ? (
            <Reveal delay={0.16}>
                <p className="mt-5 text-zinc-400 font-light leading-relaxed">{subtitle}</p>
            </Reveal>
        ) : null}
    </div>
);

export default Reveal;
